// @flow

import withNotification from './hoc/withNotification'
import duck from './duck'

export default {
  withNotification,
  duck,
}
